module.exports = __webpack_public_path__ + "static/media/autocad-logo.59d0cf67.png";